<script setup>
const props = defineProps({
  color: { type: String, default: '#888' },
  initials: { type: String, required: true },
  size: { type: Number, default: 32 },
});
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"
    :style="{ width: size + 'px', height: size + 'px', display: 'inline-block' }">
    <circle cx="16" cy="16" r="16" :fill="color" />
    <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14"
      font-family="inherit" font-weight="bold">
      {{ initials }}
    </text>
  </svg>
</template>